import type { RegulatedEquipmentClassRow } from '@safetyhub/shared';
import { api } from './api';

/**
 * 법정 설비 판정 재료(②-c2 E1) — 서버 `GET :siteId/equipment-legal` · `PATCH :siteId/equipment-review`.
 *
 * ⚠️ 이 모듈을 `lib/site-metadata.ts`에 합치지 말 것 — 그 모듈을 `vi.mock`하는 spec이 여럿이라(사진 메타·점검 목록 훅)
 * 새 export를 거기 두면 그 spec 전부가 「No export is defined on the mock」로 죽는다(CLAUDE.md 「vi.mock 모듈에 새 export」).
 * 판정은 서버와 **같은 함수**(shared `judgeRegulatedEquipment`)로 화면이 직접 한다 — 결과를 받지 않는다.
 */
export interface RegulatedEquipmentClassView extends RegulatedEquipmentClassRow {
  sortOrder: number;
}

export interface SiteEquipmentLegalContext {
  /** 분류 표 — 서버가 목록 참조(49종 `optionsFromList`·규칙 `@list:`)를 **해석한** 행(화면은 목록을 모른다) */
  classes: RegulatedEquipmentClassView[];
  /** 「설비 검토 완료」 시각(ISO) · null = 검토 안 함 */
  equipmentReviewedAt: string | null;
  /** 배기 공정 고르기의 선택지 — 이 현장의 활성 측정 공정(법정 서류 「측정 대상」 명부의 공정) */
  processes: { id: string; name: string }[];
}

export const regulatedEquipmentQueryKeys = {
  legal: (orgId: string, siteId: string) => ['site-equipment-legal', orgId, siteId] as const,
};

export async function getSiteEquipmentLegal(orgId: string, siteId: string): Promise<SiteEquipmentLegalContext> {
  const res = await api.get<{ success: boolean; data: SiteEquipmentLegalContext }>(
    `/organizations/${orgId}/sites/${siteId}/equipment-legal`,
  );
  return res.data.data;
}

export async function setSiteEquipmentReview(
  orgId: string,
  siteId: string,
  reviewed: boolean,
): Promise<{ equipmentReviewedAt: string | null }> {
  const res = await api.patch<{ success: boolean; data: { equipmentReviewedAt: string | null } }>(
    `/organizations/${orgId}/sites/${siteId}/equipment-review`,
    { reviewed },
  );
  return res.data.data;
}
